module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bg-4f2a9bbb4c1ea18ea4dd2acca5d79160.svg";